import { render, staticRenderFns } from "./UnauthorisedAccessEdit.vue?vue&type=template&id=20cb1ee5"
import script from "./UnauthorisedAccessEdit.vue?vue&type=script&lang=js"
export * from "./UnauthorisedAccessEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports